module.exports = __webpack_public_path__ + "img/1671716234971strublogo.cd749f12.jpg";